import React from 'react';
import { Icon } from './Icon.js';
export const IconVShapedArrowRightFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M5.35379 0.804807C5.108 0.471685 4.6383 0.400991 4.30496 0.646604C3.97184 0.892396 3.90115 1.3621 4.14676 1.69543L7.31864 6.00012L4.14676 10.3048C3.90115 10.6381 3.97184 11.1078 4.30496 11.3536C4.6383 11.5992 5.108 11.5286 5.35379 11.1954L8.85379 6.44543C9.04874 6.18087 9.04874 5.81937 8.85379 5.55481L5.35379 0.804807Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconVShapedArrowRightFill12.js.map